import { type RunHandle, type Runner, type RunRequest, startRun } from "@codeshare/runner-core";

export { findPpxTests, isAlcotestMain, testName } from "./ocamltests";
export {
  DEFAULT_OCAML_COMPILER,
  isOcamlCompiler,
  OCAML_COMPILERS,
  type OcamlCompiler,
} from "./version";

/**
 * Runs OCaml (or OxCaml, with `toolchain: "oxcaml"`) in a worker: the entry file and its sibling
 * modules are typechecked together, then run, by a toplevel that downloads on first use.
 */
export const ocamlRunner: Runner = {
  id: "ocaml",
  name: "OCaml",
  tests: "let%test and let%expect_test (ppx_inline_test, ppx_expect), or Alcotest.run",
  run(request: RunRequest, options: { timeoutMs?: number } = {}): RunHandle {
    return startRun({
      createWorker: () =>
        new Worker(new URL("./ocaml.worker.ts", import.meta.url), { type: "module" }),
      request,
      ...options,
    });
  },
};
